var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1AnalyseDEau(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 119.9 155.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.4,46.2c13.5,12.4,16.4,33,7,48.7-12,20.2-39.4,25-57.9,10.5l-8,8.1c2.4,5.4,1.9,11.3-2,15.8-8,6.9-15.2,16.7-23.3,23.3-12.5,10.2-29.8-5.3-20.8-18.9,7.9-7.5,15.6-17.2,23.8-24.2,4.7-3.9,10.5-4.6,16-2.2l8-8c-9.9-12.8-11.3-30.6-2.8-44.6,12.7-21,41.7-25.1,59.8-8.5h0ZM101.9,96.9c14.6-14,11.7-38.6-6-48.4-24.8-13.8-53.2,10.5-43.4,37.1,7.5,20.2,33.8,26.2,49.4,11.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.5,87.8c-12.8,1.5-25.5-6-30.7-17.7-5.6-12.5-2-21.8,3.7-33.2C16.1,24,24.7,11.7,33.3,0c.3,0,.4.2.6.4.9.9,2.1,2.8,2.9,3.8,5.5,7.4,11,15.8,15.6,23.8.5.9,3.4,5.7,3.4,6.2,0,.3,0,.4-.2.7-.5.5-3,2-3.8,2.7-15.1,12-21.3,31.7-15.2,50.2h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1AnalyseDEau);
export default __webpack_public_path__ + "static/media/1_Analyse_d_eau.6a67c0b030d18de9ca464004de14409d.svg";
export { ForwardRef as ReactComponent };